export default __webpack_public_path__ + "static/media/polygon.184368af.png";